<template>
  <el-row :gutter="15">
    <el-col
      :xs="4"
      :sm="4"
      :md="4"
      :lg="4"
      :xl="4"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_item"
        :primary-fields="[ 'name', 'code']"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
        @sort="sort = $event; $refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="20"
      :sm="20"
      :md="20"
      :lg="20"
      :xl="20"
    >
      <el-card
        shadow="never"
      >
        <ItemsTable
          ref="table"
          :filters="filters"
          :sort="sort"
          :account-id="$route.params.accountId"
          :is-show.sync="isShowPreview"
          :is-show-import.sync="isShowImport"
        />
      </el-card>
    </el-col>
    <Preview
      v-if="isShowPreview"
      title="Item Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
    <ItemImportForm
      v-if="isShowImport"
      :is-show.sync="isShowImport"
      :account-id="this.$route.params.accountId"
    />
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import ItemsTable from '@/components/Application/Manage/Account/ItemsTable'
import Preview from '@/components/Application/Reports/Preview'
import ItemImportForm from '@/components/Application/Manage/Account/ItemImportForm'

export default {
  components: {
    Filters,
    ItemsTable,
    Preview,
    ItemImportForm
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Items',
        route: { name: 'manage-accounts-account-items', params: { accountId: this.$route.params.accountId } }
      },
      filters: [],
      isShowPreview: false,
      isShowImport: false,
      configuration: {
        report: 'Items',
        params: {
          accountId: this.$route.params.accountId,
          showChildrenAccts: false
        }
      },
      sort: {
        field: 'created_at',
        direction: 'desc'
      }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
